import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { onAudioUnlock, useSfx } from './hooks/useSfx.js';
/**
 * Sound on/off pill. Hidden until the user interacts with the page once —
 * that's when the browser actually allows audio. Shows the current mute
 * state and lets the user flip it globally via localStorage.
 */
export function SfxToggle({ variant = 'pill', className }) {
    const sfx = useSfx();
    const [muted, setMuted] = useState(() => sfx.muted());
    const [ready, setReady] = useState(() => sfx.isUnlocked());
    useEffect(() => {
        if (ready)
            return;
        const dispose = onAudioUnlock(() => setReady(true));
        return dispose;
    }, [ready]);
    function toggle() {
        const next = !muted;
        sfx.mute(next);
        setMuted(next);
        if (!next)
            sfx.play('tap');
    }
    const label = muted ? 'Som desligado' : 'Som ligado';
    const classes = [
        variant === 'pill' ? 'sl-sfx-pill' : 'sl-sfx-icon',
        muted ? 'sl-sfx--muted' : 'sl-sfx--on',
        !ready ? 'sl-sfx--pending' : '',
        className ?? '',
    ]
        .filter(Boolean)
        .join(' ');
    return (_jsxs("button", { type: "button", className: classes, onClick: toggle, "aria-label": label, title: label, children: [_jsx("span", { "aria-hidden": true, className: "sl-sfx-icon__glyph", children: muted ? '🔇' : '🔊' }), variant === 'pill' ? (_jsx("span", { className: "sl-sfx-pill__label", children: muted ? 'MUDO' : 'SOM' })) : null] }));
}
//# sourceMappingURL=SfxToggle.js.map